/**
 * LoveLab PDP mobile gallery — React ProductGallery MobileSwipeGallery parity.
 * Turns .ll-cuty-media-list into a horizontal scroll-snap carousel < 1024px
 * with ink-plum dots. Desktop keeps the vertical stack, except lists marked
 * with [data-ll-pdp-carousel] (e.g. Holy necklace) which stay carousels.
 */
(function () {
  var MQ = '(max-width: 1023px)';
  var ATTR = 'data-ll-mobile-gallery';

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function isAlwaysCarousel(list) {
    return list.hasAttribute('data-ll-pdp-carousel') || list.classList.contains('ll-cuty-media-list--pdp-carousel');
  }

  function carouselActive(list) {
    return isMobile() || isAlwaysCarousel(list);
  }

  function visibleSlides(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      if (!el.classList || !el.classList.contains('ll-cuty-media-item')) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function ensureShell(list) {
    if (list.closest('.ll-mobile-gallery')) return list.closest('.ll-mobile-gallery');
    var shell = document.createElement('div');
    shell.className = 'll-mobile-gallery';
    list.parentNode.insertBefore(shell, list);
    shell.appendChild(list);
    return shell;
  }

  function buildDots(shell, count, jump) {
    var existing = shell.querySelector('.ll-mobile-gallery__dots');
    if (existing) existing.remove();
    if (count < 2) return null;

    var dots = document.createElement('div');
    dots.className = 'll-mobile-gallery__dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', (window.llI18n && window.llI18n.a11yProductImages) || 'Product images');

    for (var i = 0; i < count; i++) {
      (function (index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'll-mobile-gallery__dot';
        btn.setAttribute('aria-label', ((window.llI18n && window.llI18n.a11yShowImage) || 'Show image {{ index }} of {{ count }}').replace('{{ index }}', index + 1).replace('{{ count }}', count));
        if (index === 0) btn.setAttribute('aria-current', 'true');
        btn.addEventListener('click', function () {
          jump(index);
        });
        var pip = document.createElement('span');
        pip.className = 'll-mobile-gallery__dot-pip';
        btn.appendChild(pip);
        dots.appendChild(btn);
      })(i);
    }

    shell.appendChild(dots);
    return dots;
  }

  function buildNav(shell, list, jump) {
    var existing = shell.querySelectorAll('.ll-mobile-gallery__nav');
    for (var i = 0; i < existing.length; i++) existing[i].remove();
    if (!isAlwaysCarousel(list) || isMobile()) return;

    function makeBtn(dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'll-mobile-gallery__nav ll-mobile-gallery__nav--' + dir;
      btn.setAttribute('aria-label', dir === 'prev' ? (window.llI18n && window.llI18n.a11yPrevImage) || 'Previous image' : (window.llI18n && window.llI18n.a11yNextImage) || 'Next image');
      btn.innerHTML =
        dir === 'prev'
          ? '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
      btn.addEventListener('click', function () {
        var slides = visibleSlides(list);
        if (!slides.length || !list.clientWidth) return;
        var idx = Math.round(list.scrollLeft / list.clientWidth);
        jump(dir === 'prev' ? Math.max(0, idx - 1) : Math.min(slides.length - 1, idx + 1));
      });
      shell.appendChild(btn);
    }

    makeBtn('prev');
    makeBtn('next');
  }

  function setActiveDot(dots, index) {
    if (!dots) return;
    var buttons = dots.querySelectorAll('.ll-mobile-gallery__dot');
    for (var i = 0; i < buttons.length; i++) {
      if (i === index) buttons[i].setAttribute('aria-current', 'true');
      else buttons[i].removeAttribute('aria-current');
    }
  }

  function initList(list) {
    if (list.getAttribute(ATTR) === '1') return;
    list.setAttribute(ATTR, '1');

    var shell = ensureShell(list);
    list.classList.add('ll-cuty-media-list--gallery');
    list.setAttribute('role', 'region');
    list.setAttribute('aria-roledescription', 'carousel');
    list.setAttribute('aria-label', (window.llI18n && window.llI18n.a11yProductImages) || 'Product images');

    var dots = null;
    var activeIdx = 0;

    function jumpTo(i) {
      if (!carouselActive(list)) return;
      list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' });
    }

    function refreshDots() {
      if (!carouselActive(list)) {
        if (dots) {
          dots.remove();
          dots = null;
        }
        shell.querySelectorAll('.ll-mobile-gallery__nav').forEach(function (n) {
          n.remove();
        });
        return;
      }
      var slides = visibleSlides(list);
      dots = buildDots(shell, slides.length, jumpTo);
      buildNav(shell, list, jumpTo);
      setActiveDot(dots, Math.min(activeIdx, Math.max(0, slides.length - 1)));
    }

    function onScroll() {
      if (!carouselActive(list) || !list.clientWidth) return;
      var idx = Math.round(list.scrollLeft / list.clientWidth);
      if (idx !== activeIdx) {
        activeIdx = idx;
        setActiveDot(dots, activeIdx);
      }
    }

    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      refreshDots();
      if (!carouselActive(list)) {
        list.scrollLeft = 0;
        activeIdx = 0;
      }
    });

    var mo = new MutationObserver(function () {
      refreshDots();
    });
    mo.observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });

    refreshDots();
  }

  function init() {
    document.querySelectorAll('.ll-cuty-media-list').forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
